import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { posthog } from 'posthog-js';
import { Route, Routes } from 'react-router-dom';
import LoadingEnvironmentScreen from '../LoadingEnvironmentScreen/LoadingEnvironmentScreen';
import BrowserRecipeScreen from '../BrowserRecipeScreen/BrowserRecipeScreen';
import ViewRecipe from '../directView/recipe/ViewRecipe';
import PageNotFound from '../404/PageNotFound';
import DesktopRecipeScreen from '../DesktopRecipeScreen/DesktopRecipeScreen';
import LoadRecipeFileContentsFromDisk from '../LoadRecipeFileContentsFromDisk/LoadRecipeFileContentsFromDisk';
import RecipeRouter from './RecipeRouter';
import SaveRecipeModal from '@components/SaveRecipeModal/SaveRecipeModal';
import SecretMappingModal from '@components/SecretMappingModal/SecretMappingModal';
import DeployRecipeModal from '@components/DeployRecipeModal/DeployRecipeModal';
import ManageEnvironmentsModal from '@components/ManageEnvironmentsModal/ManageEnvironmentsModal';
import GlobalNotifications from '@components/GlobalNotifications/GlobalNotifications';
import WithSuspenseLoader from '@components/WithSuspenseLoader/WithSuspenseLoader';
import RecipeDownloadIndicator from '@components/recipeDownloadIndicator/recipeDownloadIndicator';
import RecipeUploadProgress from '@components/recipeUploadProgress/recipeUploadProgress';
import SaveRecipeIndicator from '@components/saveRecipeIndicator/saveRecipeIndicator';
import VersionAvailablePopup from '@components/versionAvailablePopup/VersionAvailablePopup';
import WidgetAsyncIndicator from '@components/widgetAsyncIndicator/widgetAsyncIndicator';
import CheckoutModal from '../CheckoutModal/CheckoutModal';
import CheckoutDrawer from '../CheckoutModal/CheckoutDrawer/CheckoutDrawer';
import HubContextProvider from '@common/context/HubContext/HubContext';
import routes from '@common/routes/index';
// import EnvironmentModal from '../EnvironmentModal/EnvironmentModal';
// const BrowserRecipeScreen = React.lazy(() => import('../BrowserRecipeScreen/BrowserRecipeScreen'));
import MarketplaceLayout from '@components/layout/marketplace/marketplace';
// const MarketplaceLayout = lazy(() => import('@components/layout/marketplace/marketplace.tsx'));
import { selectSignedUserProfile } from '@src/app/reducers/user/userSlice';
import globals from '@common/globals';
// import { initFreshChatWidget } from '@src/app/recipe/freshChatWidget';
// import { initFreshDeskWidget } from '@src/app/recipe/freshDeskWidget';
// import helpHero from '@common/helpHero/helpHero';
import { AsyncRequestStatus } from '@src/types/core_t';
import useTranslation from '@hooks/useTranslation';
import useQueryString from '@hooks/useQueryString';
import OnboardingManager from '../OnboardingManager/OnboardingManager';
import useHasPosthogFeature from '@hooks/useHasPosthogFeature';
import historyToggle from '@src/app/reducers/history/historyToggle';
import { selectOpeningRecipe } from '../Workspace/workspaceSlice';

// import { createBrowserRecipeAction } from '@src/app/reducers/workspace/createBrowserRecipeReducer';
// import useWebsocketConnection from '@hooks/useWebsocketConnection';
// import WebsocketConnector from '../WebsocketConnector/WebsocketConnector';

type ReducedSessionInfo = {
	attributes: Record<string, string>;
	state: string;
}

/** Used to identify the user in posthog */
const IdentifyPostHogUser = () => {
	const userProfile = useSelector(selectSignedUserProfile);
	const [hasFeature, ready] = useHasPosthogFeature('history');
	const initializedRef = useRef(false);

	useEffect(() => {
		if (ready && hasFeature) {
			console.log('Enabling history');
			historyToggle.enableHistory();
		}
	}, [ready, hasFeature]);

	useEffect(() => {
		if (!userProfile.profile || initializedRef.current) {
			return;
		}

		initializedRef.current = true;
		// posthog.init(
		// 	globals.POSTHOG_PROJECT_API_TOKEN,
		// 	{
		// 		defaults: '2025-05-24',
		// 		api_host: 'https://us.i.posthog.com',
		// 		autocapture: false,
		// 		'opt_in_site_apps': true,
		// 		person_profiles: 'identified_only',
		// 		enable_recording_console_log: true,
		// 	}
		// );

		posthog.identify(userProfile.profile.id, {
			id: userProfile.profile.id,
			firstName: userProfile.profile.firstName,
			lastName: userProfile.profile.lastName,
			email: userProfile.profile.email,
			plan: userProfile.profile.organizationId ? 'organization' : 'individual',
			webAppVersion: globals.WEB_APP_VERSION,
		});
	}, [userProfile.profile]);

	return null;
};

export const Kemu = (): React.JSX.Element | null => {
	const userProfile = useSelector(selectSignedUserProfile);
	const t = useTranslation();
	const openingRecipe = useSelector(selectOpeningRecipe);
	const environmentLoaded = userProfile.asyncState.status === AsyncRequestStatus.completed;
	
	// const isLoggedIn = session.state === 'LoggedIn';
	// const { id: recipeIdInPath } = useParams<{id?: string}>();
	const queryStr = useQueryString();
	const inMarketplace = queryStr.get('marketplace') === 'true';
	// const { readyState } = useWebsocketConnection();
	// TODO: make this dynamic depending on user locale
	// initFreshDeskWidget('en');

	// const freshChatWidget = initFreshChatWidget();
	// Convert the data we use to a primitive to prevent re-rendering this component when the session object changes
	// const userInfoStr = JSON.stringify({
	// 	attributes: session.user?.attributes,
	// 	state: session.state,
	// } as ReducedSessionInfo);

  // useEffect(() => {
	// 	// Account setup not completed yet, redirect to config
	// 	const userInfo = JSON.parse(userInfoStr) as ReducedSessionInfo;
	// 	if (userInfo.state === 'LoggedIn' && userInfo.attributes) {
	// 		// Fetch user profile
	// 		dispatch(fetchUserProfileAction());

	// 		/* if (!userInfo.attributes['custom:organization']) {
	// 			navigate(routes.auth.getAccountSelectionWithUserRoute(userInfo.attributes['sub']));
	// 		} */
	// 	}
	// }, [userInfoStr, dispatch]);


	// Sets the user info in the chat widget and posthog
	// useEffect(() => {
	// 	if (userProfile.profile) {
	// 		// const helphero = helpHero.initialize(globals.HELP_HERO_APP_ID);

	// 		/* helphero.identify(userProfile.profile.id, {
	// 			id: userProfile.profile.id,
	// 			firstName: userProfile.profile.firstName,
	// 			lastName: userProfile.profile.lastName,
	// 			email: userProfile.profile.email,
	// 			plan: userProfile.profile.organizationId ? 'organization' : 'individual'
	// 		}); */

	// 		// posthog.init(
	// 		// 	globals.POSTHOG_PROJECT_API_TOKEN,
	// 		// 	{
	// 		// 		api_host: 'https://us.i.posthog.com',
	// 		// 		autocapture: false,
	// 		// 		'opt_in_site_apps': true,
	// 		// 	}
	// 		// );

	// 		// posthog.identify(userProfile.profile.id, {
	// 		// 	id: userProfile.profile.id,
	// 		// 	firstName: userProfile.profile.firstName,
	// 		// 	lastName: userProfile.profile.lastName,
	// 		// 	email: userProfile.profile.email,
	// 		// 	plan: userProfile.profile.organizationId ? 'organization' : 'individual',
	// 		// 	webAppVersion: globals.WEB_APP_VERSION,
	// 		// });

	// 		// Set userback user info
	// 		/* const userBackInstance = getUserbackInstance();
	// 		if (userBackInstance) {
	// 			userBackInstance.email = userProfile.profile.email as string;
	// 			userBackInstance.name = `${userProfile.profile.firstName} ${userProfile.profile.lastName}`;
	// 			// NOTE: Requires 'Company' or 'Premium' plan. Not currently working.
	// 			userBackInstance.identify(userProfile.profile.id, {
	// 				name: `${userProfile.profile.firstName} ${userProfile.profile.lastName}`,
	// 				firstName: userProfile.profile.firstName,
	// 				lastName: userProfile.profile.lastName,
	// 				loginId: userProfile.profile.email || userProfile.profile.loginId,
	// 				plan: userProfile.profile.organizationId ? 'organization' : 'individual'
	// 			});
	// 		} */

	// 		 if (freshChatWidget.initialized) {
	// 			freshChatWidget.setUserInfo({
	// 				id: userProfile.profile.id,
	// 				firstName: userProfile.profile.firstName,
	// 				lastName: userProfile.profile.lastName,
	// 				email: userProfile.profile.email,
	// 				plan: userProfile.profile.organizationId ? 'organization' : 'individual'
	// 			});

	// 			freshChatWidget.show();
	// 		}
	// 	}
	// }, [freshChatWidget.initialized, freshChatWidget, userProfile.profile]);

	// useEffect(() => {
	// 	if (environmentLoaded && isLoggedIn && !recipeIdInPath) {
	// 		dispatch(createBrowserRecipeAction({
	// 			history
	// 		}));
	// 	}
	// }, [environmentLoaded, isLoggedIn, dispatch, history, recipeIdInPath]);



	// console.log(`environmentLoaded [${environmentLoaded}] `, userProfile);
	if (!environmentLoaded || openingRecipe) {
		return (
			<LoadingEnvironmentScreen title={ openingRecipe ? t('Interface.OpeningRecipe') : t('Interface.LoadingEnvironment.Title')}/>
		);
	}
	
	return (
		<>
			{environmentLoaded && (
				<HubContextProvider>
					<WithSuspenseLoader title={t('Interface.LoadingResource')}>
						{/* <KeepWaiting /> */}
						<VersionAvailablePopup />
						<SaveRecipeIndicator />
						<RecipeUploadProgress />
						<RecipeDownloadIndicator />
						<WidgetAsyncIndicator />
					<CheckoutModal />
					<CheckoutDrawer />
					<SaveRecipeModal />
					<SecretMappingModal />
					<DeployRecipeModal />
					<ManageEnvironmentsModal />
					{/* <WebsocketConnector /> */}
					<GlobalNotifications />
						<IdentifyPostHogUser />
						{/* TODO: this should show in an outlet? */}
						{inMarketplace && <MarketplaceLayout /> }

						<OnboardingManager />

						<Routes>
							<Route path={routes.recipe.getDirectRecipeRoute()} element={<ViewRecipe />} />
							<Route path={routes.recipe.getBrowserRecipeRoute()} element={<BrowserRecipeScreen />} />
							<Route path={routes.recipe.getDesktopRecipeRoute()} element={<DesktopRecipeScreen />} />
							<Route path={routes.recipe.getLoadRecipeFileContentsFromCacheRoute()} element={<LoadRecipeFileContentsFromDisk />} />

							{/* <Route path={routes.marketplace.getMarketplaceRoute()} element={<MarketplaceLayout />} /> */}
							<Route path={routes.getBaseRoute()} element={<RecipeRouter />} />

							<Route path="*" element={<PageNotFound />} />
						</Routes>
					</WithSuspenseLoader>
				</HubContextProvider>
			)}

		</>
	);
};
